module.exports = __webpack_public_path__ + "media/images/flags/64/South-Sudan-7d2694bc6b53f58a9ea99818acf5db57.png";